export default "__VITE_PUBLIC_ASSET__7f9974a0__"